import {
  Row,
  Col,
  Typography,
  Icon,
  Button,
  Slider,
  Skeleton,
} from '@repo/ui/components'
import { cn } from '@repo/ui/lib'

export interface BalanceSliderProps {
  title: string
  value: number
  max?: number
  onChange: (value: number) => void
  onCommit: (value: number) => void
  currencyLabel: string
  onMaxClick?: () => void
  color?: 'positive' | 'neutral' | 'negative'
  inputCurrency?: 'IRR' | 'TMN'
  outputCurrency?: 'IRR' | 'TMN'
  availableBalance?: string
  disabled?: boolean
  tab?: 'buy' | 'sell' | 'convert'
  token?: string
  loading?: boolean
  removeSpaceBetweenVertical?: boolean
  titleProps?: React.ComponentProps<typeof Typography>
  kind?: string
}

export const BalanceSlider = (props: BalanceSliderProps) => {
  const {
    title,
    value,
    max,
    onChange,
    onCommit,
    currencyLabel,
    onMaxClick,
    color = 'positive',
    availableBalance,
    disabled = false,
    tab = 'buy',
    token,
    loading,
    removeSpaceBetweenVertical = false,
    titleProps,
    kind,
  } = props
  return (
    <Col
      className={cn('mb-md', removeSpaceBetweenVertical ? 'gap-0' : 'gap-xs')}
    >
      {title && (
        <Row
          className={cn(
            'justify-between items-center',
            removeSpaceBetweenVertical ? 'mb-0' : 'mb-xs',
          )}
        >
          <Typography
            size='sm'
            color='text-neutral-surface-80'
            className='whitespace-nowrap'
            {...titleProps}
          >
            {title}
          </Typography>
          <Row className='items-center gap-xs justify-end'>
            {loading ? (
              <Skeleton className='h-4 w-16 my-2xs' />
            ) : (
              <Typography size='md' weight='bold' color='text-neutral-main'>
                {kind === 'crypto'
                  ? availableBalance
                  : Number(
                      Number(availableBalance || 0).toFixed(0),
                    ).toLocaleString()}
              </Typography>
            )}
            <Typography size='xs' color='text-neutral-surface-80'>
              {currencyLabel}
            </Typography>
            {onMaxClick ? (
              <Button
                type='button'
                size='sm'
                variant='ghost'
                className='p-3xs rounded-xs'
                onClick={onMaxClick}
                aria-label='Max Balance'
                startIcon={
                  <Icon name='PlusLine' size='md' color='fill-base-main' />
                }
              />
            ) : (
              <div className='h-[32px] relative' />
            )}
          </Row>
        </Row>
      )}

      <Slider
        min={0}
        max={100}
        value={[typeof value === 'number' ? value : 0]}
        onValueChange={([val]) => onChange(val as number)}
        className={title ? 'mt-xs' : ''}
        color={color}
        onValueCommit={([val]) => {
          const _value = ((val as number) * (max as number)) / 100
          onCommit(kind === 'crypto' ? _value : Number(_value.toFixed(0)))
        }}
        disabled={disabled}
        step={1}
      />
    </Col>
  )
}
